import { jwtDecode } from 'jwt-decode';

export const isValidToken = (accessToken: string | null | undefined) => {
  if (!accessToken) return false;
  const decoded = jwtDecode<{ exp: number; Roles: string[] }>(accessToken);
  const currentTime = Date.now() / 1000;
  return decoded.exp > currentTime;
};

export const hasPermission = (permissionList: number[], permission: number) =>
  permissionList.includes(permission);
